import React from 'react';
import styled from 'styled-components';

const Container = styled.section`
  background-color: #FFFFFF;
  padding: 40px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -40px;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 32px;
  text-align: center;
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  gap: 40px;
  max-width: 1100px;
  width: 100%;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Icon = styled.img`
  width: 64px;
  height: 64px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

const TextContent = styled.div`
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #111;
  margin-bottom: 4px;
`;

const Description = styled.p`
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;
`;

export default function BarraDeInformacoes() {
  return (
    <Container>
      <SectionTitle>Como podemos te ajudar?</SectionTitle>
      <StepsContainer>
        <StepItem>
          <Icon src="/images/mao.png" alt="Ícone mão" />
          <TextContent>
            <Title>Escolha seu plano</Title>
            <Description>Encontre o plano que melhor atende suas necessidades e estilo de vida.</Description>
          </TextContent>
        </StepItem>
        <StepItem>
          <Icon src="/images/celular.png" alt="Ícone celular" />
          <TextContent>
            <Title>Acesse os serviços</Title>
            <Description>Consulte, agende e acompanhe serviços diretamente pelo nosso portal.</Description>
          </TextContent>
        </StepItem>
        <StepItem>
          <Icon src="/images/pasta.png" alt="Ícone pasta" />
          <TextContent>
            <Title>Use seus benefícios</Title>
            <Description>Tenha acesso a consultas, exames, telemedicina e descontos especiais.</Description>
          </TextContent>
        </StepItem>
        <StepItem>
          <Icon src="/images/relogio.png" alt="Ícone relógio" />
          <TextContent>
            <Title>Cuidamos de você</Title>
            <Description>Conte com nossa rede credenciada para saúde, bem-estar e qualidade de vida.</Description>
          </TextContent>
        </StepItem>
      </StepsContainer>
    </Container>
  );
}
